
export const config = {

  baseURL: process.env.VUE_APP_BASE_API,

  timeout: 60000,

}